module.exports = __webpack_public_path__ + "static/img/qes_bj.b26d761.png";